<template>
  <div class="container">
    <img
      class="warning-img"
      width="88"
      src="@/assets/round-red-exclamation-mark.svg"
    />
    <h1 class="title">{{ $t('swap.areYouSure') }}</h1>
    <h3 class="description">
      {{ $t('swap.priceImpactAlert', [priceImpact]) }}
    </h3>
    <div class="button-wrapper">
      <PButton
        class="p-button-secondary button"
        @click="onClickAction('cancel')"
      >
        {{ $t('common.cancel') }}
      </PButton>
      <PButton
        class="p-button-secondary button button_warning"
        @click="onClickAction('swap')"
      >
        {{ $t('swap.swap') }}
      </PButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, inject } from 'vue';

const dialogRef = inject('dialogRef');
const priceImpactData: number | undefined = dialogRef?.value?.data?.priceImpact;

const priceImpact = computed(() =>
  priceImpactData ? priceImpactData.toFixed(2) : '0.00',
);

function onClickAction(type: 'cancel' | 'swap') {
  dialogRef.value.close({ type });
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.warning-img {
  margin-bottom: 38px;
}

.title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #ffffff;
  margin-top: 0;
}

.description {
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.44px;
  color: var(--text-color);
  margin-top: 0;
  text-align: center;
}

.button-wrapper {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.button {
  display: flex;
  justify-content: center;
  width: 196px;

  &_warning {
    background-color: var(--accent-error);

    &:hover {
      background-color: #d75050 !important;
    }
  }

  @media screen and(max-width:767px) {
    width: 150px;
  }
}
</style>
